export const dataStatus = [
  { value: '1', label: 'Aktif' },
  { value: '0', label: 'Tidak Aktif' },
];
